/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  InputLabel,
  TextField,
  OutlinedInput,
  InputAdornment,
  Paper,
  Link,
  FormHelperText,
} from '@mui/material';
import MainLogo from '../../../components/MainLogo/MainLogo.components';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useLogin } from '../hooks/useLogin';

const ChangeEmail = ({ setChng, email }: { setChng: (arg0: any) => void; email: string }) => {
  // Start Input Password Code
  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }
  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
    showNewPassword: false,
  });
  const handleChange = (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleClickShowNewPassword = () => {
    setValues({
      ...values,
      showNewPassword: !values.showNewPassword,
    });
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const validationSchema = yup.object({
    email: yup.string().email('Enter a valid email').required('Email is required'),
    newEmail: yup.string().email('Enter a valid new email').required('New Email is required'),
    otp: yup.string().required('Code is required'),
  });

  const { getEmailOtp, changeEmail } = useLogin();

  const formik = useFormik({
    initialValues: {
      email,
      newEmail: '',
      otp: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      changeEmail(values, setChng);
      // alert(JSON.stringify(values, null, 2));
    },
  });

  // End Input Password Code
  return (
    <form onSubmit={formik.handleSubmit}>
      <Paper className="UpdateEmailBox" style={{ marginTop: 10 }}>
        <Paper>
          <Typography variant="h6" className="AccountHeading">
            <b>Change Email *</b>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Check your inbox, we sent a code to {email}
            </Typography>
          </Typography>
          <Paper className="CurrentEmailBox">
            <Box className="CommonFormControl" sx={{ mt: 3 }}>
              <InputLabel>New Email *</InputLabel>
              <TextField
                label=""
                variant="outlined"
                name="newEmail"
                value={formik.values.newEmail}
                onChange={formik.handleChange}
                error={formik.touched.newEmail && Boolean(formik.errors.newEmail)}
                helperText={formik.touched.newEmail && formik.errors.newEmail}
              />
            </Box>
          </Paper>
          <Paper className="OtpCodeBox">
            <Box className="CommonFormControl" sx={{ mt: 3 }}>
              <InputLabel>Code *</InputLabel>
              <TextField
                label=""
                variant="outlined"
                name="otp"
                value={formik.values.otp}
                onChange={formik.handleChange}
                error={formik.touched.otp && Boolean(formik.errors.otp)}
                helperText={formik.touched.otp && formik.errors.otp}
              />
            </Box>
            <Box>
              <Typography variant="body1">
                Didn’t get a code? <Link onClick={() => getEmailOtp()}>Resend code</Link>
              </Typography>
            </Box>
          </Paper>
          <Box className="FooterButton" sx={{ mt: 4 }}>
            <Button
              className="CommonModalButton FullWidthButton"
              color="primary"
              variant="outlined"
              onClick={() => {
                formik.resetForm();
                setChng(null);
              }}
            >
              Cancel
            </Button>
            <Button
              className="CommonModalButton FullWidthButton"
              color="primary"
              variant="contained"
              type="submit"
            >
              Continue
            </Button>
          </Box>
        </Paper>
      </Paper>
    </form>
  );
};

export default ChangeEmail;
